import { Box, Divider } from "@mui/material"
import { OATypography } from "../../../../components/widgets"
import { ReactComponent as AddressIcon } from '../../../../assets/icons/Address.svg';
import { ReactComponent as StarIcon } from '../../../../assets/icons/hotelRating.svg';
import { ReactComponent as NonStarIcon } from '../../../../assets/icons/nonRatingStart.svg';
import OAButton from "../../../../components/widgets/OAButton";
interface IHotelInfo {
  hotelInfo: any;
  roomInfo: any;
}

export const HotelInfo = (props: IHotelInfo) => {
  const { hotelInfo, roomInfo } = props;
  
  const handleViewInMap = () => {
    if (hotelInfo?.location?.lat && hotelInfo?.location?.lon) {
      const url = `https://www.google.com/maps?q=${hotelInfo?.location?.lat},${hotelInfo?.location?.lon}&z=5`;
      window.open(url, '_blank');
    }
  };
  
  return (
    <div className='order-view--activity card pb-6'>
      {roomInfo?.map((room:any, index:number) => (
        <Box key={index} display="flex">
          <Box marginTop="21px" marginLeft="16px" marginBottom="16px">
            <Box display="flex" justifyContent="flex-start" alignItems="center" gap="10px">
              <OATypography
                variant="h4"
                sx={{
                  width: "28px",
                  height: "25px",
                  backgroundColor: "#EBF3FF",
                  borderRadius: "2px",
                  paddingRight: "4px",
                  paddingLeft: "4px"
                }}
              >
                {room?.count}x
              </OATypography>
              <OATypography variant="h4">{room?.displayName}</OATypography>
            </Box>
            <OATypography
              variant="body2"
              marginLeft="38px"
              sx={{ color: "#616876" }}
            >
              {room?.mealType?.replace(/_/g, " ")}
            </OATypography>
          </Box>
          <Box marginTop="21px" marginLeft="16px" marginBottom="16px">
          <OAButton
            label='View In Map'
            onClick={handleViewInMap}
            size="sm"
          />
          </Box>
          <Divider />
        </Box>
      ))}
        <Box display="flex" alignItems="center" margin="24px">
         <Box>
            <Box display="flex" justifyContent="start" alignItems="center">
              <OATypography variant="body2" sx={{fontSize: "16px", color: "#616876"}}>Check in time</OATypography>
              <OATypography variant="body2" sx={{fontSize: "16px", paddingLeft: "33px"}}>{hotelInfo?.checkInTime}</OATypography>
            </Box>
            <Box display="flex" justifyContent="start" alignItems="center" marginTop="20px">
              <OATypography variant="body2" sx={{fontSize: "16px", color: "#616876"}}>Contact number</OATypography>
              <OATypography variant="body2" sx={{fontSize: "16px", paddingLeft:"14px"}}>{hotelInfo?.phones?.[0]}</OATypography>
            </Box>
            <Box display="flex" justifyContent="start" alignItems="center" marginTop="20px">
              <OATypography variant="body2" sx={{fontSize: "16px", color: "#616876"}}>Star Rating</OATypography>
              <Box display="flex" alignItems="center" sx={{paddingLeft:"57px"}}>
                {[...Array(5)].map((_, index) => (
                  index < Number(hotelInfo?.hotelRating || 0) ? (
                    <StarIcon key={index} style={{marginRight: "4px"}} />
                  ) : (
                    <NonStarIcon key={index} style={{marginRight: "4px"}} />
                  )
                ))}
              </Box>
            </Box>
         </Box>
         <Box>
            <Box display="flex" justifyContent="start" alignItems="center">
              <OATypography variant="body2" sx={{fontSize: "16px", color:"#616876", paddingLeft: "90px"}}>Check out time</OATypography>
              <OATypography variant="body2" sx={{fontSize: "16px", paddingLeft:"22px"}}>{hotelInfo?.checkOutTime}</OATypography>
            </Box>
            <Box display="flex" justifyContent="start" alignItems="center" marginTop="20px">
              <OATypography variant="body2" sx={{fontSize: "16px", color:"#616876", paddingLeft: "90px"}}>Fax number</OATypography>
              <OATypography variant="body2" sx={{fontSize: "16px", paddingLeft:"47px"}}>{hotelInfo?.faxNumber ?? 'N/A'}</OATypography>
            </Box>
            <Box display="flex" justifyContent="start" alignItems="center" marginTop="20px">
              <OATypography variant="body2" sx={{fontSize: "16px", color:"#616876", paddingLeft: "90px"}}>City Name</OATypography>
              <OATypography variant="body2" sx={{fontSize: "16px", paddingLeft:"60px"}}>{hotelInfo?.cityName}</OATypography>
            </Box>
         </Box>
        </Box>
        <Box display="flex" justifyContent="start" alignItems="center" margin="0px 0px 21px 24px">
            <OATypography variant="body2" sx={{fontSize: "16px", color: "#616876"}}>Address</OATypography>
            <AddressIcon style={{paddingLeft: "5px", width: "22px"}}/>
            <OATypography variant="body2" sx={{fontSize: "16px", paddingLeft:"57px"}}>{hotelInfo?.address}</OATypography>
        </Box>
    </div>
  )

}
